const underwritingAutomationStatus = {
    FORCE_DISABLED : -1,

    DISABLED : 0,

    AUTO_CREATE_QUOTE : 4,

    AUTO_RATE : 6,

    AUTO_QUOTE : 8,

    AUTO_SEND_QUOTE : 10,

    AUTO_BIND : 20,

    AUTO_ISSUE : 30

};

angular.module('gw-um-j2js')
    .constant('underwritingAutomationStatus', underwritingAutomationStatus);